import ClauseValueDropdownData from '../../store/schema/ClauseValueDropdownData';
import strings from 'owa-strings/owa-options-strings';

export default function getSensitivityOptions(): ClauseValueDropdownData[] {
    return [
        { value: 'CompanyConfidential', text: strings.options_inboxRules_companyConfidential },
        { value: 'Normal', text: strings.options_inboxRules_normal },
        { value: 'Personal', text: strings.options_inboxRules_personal },
        { value: 'Private', text: strings.options_inboxRules_private },
    ];
}
